// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"a23b773e","66":"ac92faa9","78":"4994b86f","319":"9a5e31f3","390":"91c0a25e","677":"1f5d846e","733":"55a9f09f","802":"5f7fb2b5","936":"bbbec683","949":"b0d96bc8","952":"b32ccbe0"}[chunkId] + ".chunk.js";
};